module.exports = __webpack_public_path__ + "static/media/Nude_thumb.1895eaba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/colours/Nude_thumb.jpg
// module id = 117
// module chunks = 0